/**
 * components/completed.js
 *
 */

const FilterList = require('./filter');

module.exports = FilterList(record => !record.get('completed'));



/** WEBPACK FOOTER **
 ** ./src/components/completed.js
 **/